import { Box, HStack, Tooltip, useMultiStyleConfig } from '@chakra-ui/react';
import { useContext } from 'react';
import { SlideDrawerContext } from '@investigator/shared/providers';
import { Detection } from '@investigator/shared/generated/graphql';
import { SeverityScore, TruncatedText } from '@investigator/shared/components';

interface RelatedDetectionItem {
  detection_id: string;
  alert_name: string;
  entity_name: string;
  severity: number;
  rank?: {
    is_custom_severity: boolean;
  };
}

interface RelatedDetectionRowProps {
  item: RelatedDetectionItem;
  selectedDetection?: Detection;
  setSelectedDetectionId: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}

export const RelatedDetectionRow = ({
  item,
  selectedDetection,
  setSelectedDetectionId,
}: RelatedDetectionRowProps) => {
  const styles = useMultiStyleConfig('DataList', {
    layerStyle: 'first',
  });

  const { setIsSlideDrawerOpen } = useContext(SlideDrawerContext);

  return (
    <HStack
      p={4}
      cursor="pointer"
      alignItems="center"
      data-testid="detection-row"
      borderTop="solid 1px"
      borderTopColor="border.1"
      __css={
        item.detection_id === selectedDetection?.detection_id
          ? styles.selectedItem
          : styles.item
      }
      onClick={() => {
        setIsSlideDrawerOpen?.(false);
        setSelectedDetectionId(item.detection_id);
      }}
    >
      {item?.severity && (
        <Box flexShrink={0}>
          <SeverityScore score={item.severity} />
        </Box>
      )}
      <Tooltip label={`${item?.alert_name} ${item?.entity_name}`}>
        <Box
          alignItems="start"
          whiteSpace="nowrap"
          maxWidth="100%" // Constrain the width of the Box to the parent
          overflow="hidden" // Prevent content from breaking out
        >
          <TruncatedText textStyle="body-md">{item?.alert_name}</TruncatedText>
          <TruncatedText textStyle="body-md" color="text.secondary">
            {item?.entity_name}
          </TruncatedText>
        </Box>
      </Tooltip>
    </HStack>
  );
};
